

    import Vue from 'vue';
    import MaterialCard from "../views/base/MaterialCard.vue";
    import partyService from "../services/party.service"
    import {eventBus} from "@/services/event-bus";
    import Party from "@/models/party";
    import utils from "@/services/utils";
    import ViewWeekSchedulerSummary from "@/components/ViewWeekSchedulerSummary.vue";

    export default Vue.extend({
        name: 'UserList',

        props: {
            userType: {type: String, required: true},
        },
        watch: {
            userType: function (val, oldVal) {
                if (val !== oldVal) {
                    this.loadItems();
                }
            }
        },
        components: {
            baseMaterialCard: MaterialCard,
            schedulerSummary: ViewWeekSchedulerSummary
        },
        methods: {
            setElements: function (d: any) {
                this.loading = false;
                return this.elements = d;
            },
            loadItems() {
                this.loading = true;
                if (this.userType == 'therapist') {
                    return partyService.allTherapist().then(d => this.setElements(d)).catch(reason => eventBus.$emit('error', reason));
                }
                return partyService.allPatients().then(d => this.setElements(d)).catch(reason => eventBus.$emit('error', reason));
            },
            getActivitiesAsString(item: Party): string {
                if (utils.isNull(item.activities)) {
                    return 'Brak';
                }
                return item!.activities!.map(value => value.name).join(', ');
            },
            filterDeep(value: any, search: any, item: any) {
                return value != null &&
                    search != null && (
                        (typeof value === 'string' &&
                            value.toString().indexOf(search) !== -1) ||
                        this.getActivitiesAsString(item).toString().indexOf(search) !== -1);
            },
        },
        data() {
            return {
                headers: [
                    {
                        text: this.$t('name'),
                        value: 'name',
                    },
                    {
                        text: this.$t('surname'),
                        value: 'surname',
                    },
                    {
                        text: this.$t('activities'),
                        value: 'activities',
                    },
                    {
                        text: this.$t('actions'),
                        value: 'actions',
                    },
                ],
                actions: [
                    {
                        color: 'info',
                        icon: 'mdi-calendar',
                        action: (item: any) => {
                            this.$router.push({path: `/calendar/${item.type}/${item.id}`});
                        }
                    },
                    {
                        color: 'success',
                        icon: 'mdi-chart-timeline',
                        action: (item: any) => {
                            this.$data.selectedParty = item;
                            this.$data.showSummary = true;
                        }
                    },
                ],
                elements: [] as Party[],
                search: undefined,
                loading: false,
                selectedParty: {},
                showSummary: false
            }
        },
        mounted(): void {
            this.loadItems();
        },
        errorCaptured(err: Error, vm: Vue, info: string): boolean | void {
            eventBus.$emit('error', err.message);
        }
    });
